import { createSlice } from "@reduxjs/toolkit";
import { complexedPlainText } from "../../../utils/ToPlainText";

const initialState = {
  articles: [],
  authors: [],
  exercises: [],
  metod: [],
  // categories: [],
  filteredValues: {
    articlesArr: [],
    authorsArr: [],
    exercisesArr: [],
    metodArr: [],
    // categoriesArr: [],
  },
};

export const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setArticles: (state, action) => {
      state.articles = action.payload;
    },
    setAuthors: (state, action) => {
      state.authors = action.payload;
    },
    setExercises: (state, action) => {
      state.exercises = action.payload;
    },
    setMontesoriMetod: (state, action) => {
      state.metod = action.payload;
    },
    // setCategories: (state, action) => {
    //   state.categories = action.payload;
    // },
    setFilteredValues: (state, action) => {
      if (action.payload !== "") {
        const includesText = (value) =>
          String(value || "")
            .toLowerCase()
            .includes(action.payload);

        state.filteredValues.articlesArr = state.articles.filter(
          (article) =>
            includesText(article?.title) ||
            includesText(article?.author?.name) ||
            includesText(article?.searchText)
        );

        state.filteredValues.authorsArr = state.authors.filter((author) =>
          includesText(author?.name)
        );

        state.filteredValues.metodArr = state.metod.filter((el) => {
          return (
            includesText(el?.title) ||
            includesText(complexedPlainText(el?._rawDescription || []))
          );
        });
        state.filteredValues.exercisesArr = state.exercises.filter(
          (exercise) => includesText(exercise?.heading) || includesText(exercise?.searchText)
        );

        // state.filteredValues.categoriesArr = state.categories.filter(category => category.title.toLowerCase().includes(action.payload))
      } else {
        state.filteredValues = { ...initialState.filteredValues };
      }
    },
  },
});

export const {
  setArticles,
  setExercises,
  setAuthors,
  setMontesoriMetod,
  setFilteredValues,
} = searchSlice.actions;

export default searchSlice.reducer;
